import { render, staticRenderFns } from "./BillingUpdated.vue?vue&type=template&id=5f847b22&"
import script from "./BillingUpdated.vue?vue&type=script&lang=js&"
export * from "./BillingUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports